
import {AdminStore} from '../config/store';

export const localStorageMiddleware = (store: AdminStore) => {}


